const segmentedSlippageStyle = () => ({
  slippageTabsRoot: {
    width: "190px",
    minWidth: "190px",
    height: "36px",
    minHeight: "36px",
    maxHeight: "36px",
    padding: "3px",
    position: "relative",
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    alignItems: "center",
    overflow: "hidden",
    boxSizing: "border-box",
    background: "var(--tezex-field)",
    border: "1px solid var(--tezex-line)",
    borderRadius: "999px",
  },
  slippageThumb: {
    position: "absolute",
    top: "3px",
    left: "3px",
    width: "calc((100% - 6px) / 3)",
    height: "28px",
    background: "var(--tezex-action)",
    borderRadius: "999px",
    pointerEvents: "none",
    transition: "transform 240ms cubic-bezier(.22,.8,.24,1)",
    "@media (prefers-reduced-motion: reduce)": { transition: "none" },
  },
  slippageSegment: {
    position: "relative",
    zIndex: 1,
    minWidth: 0,
    height: "28px",
    minHeight: "28px",
    maxHeight: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  slippageTab: {
    "&.MuiButtonBase-root": {
      width: "100%",
      minWidth: 0,
      height: "28px",
      minHeight: "28px",
      maxHeight: "28px",
      padding: "0 8px",
      color: "var(--tezex-muted)",
      background: "transparent",
      borderRadius: "999px",
      fontFamily: "Inter",
      fontWeight: 600,
      fontSize: "11px",
      lineHeight: 1,
      textTransform: "none",
      transition: "color 160ms ease",
      "&:hover": {
        color: "var(--tezex-text-secondary)",
        background: "transparent",
      },
      "&.Mui-disabled": {
        color: "var(--tezex-faint)",
      },
      "&.Mui-focusVisible": {
        outline: "2px solid var(--tezex-text)",
        outlineOffset: "-4px",
      },
    },
  },
  slippageTabSelected: {
    "&.MuiButtonBase-root": {
      color: "var(--tezex-action-text)",
      "&:hover": { color: "var(--tezex-action-text)" },
      "&.Mui-disabled": {
        color: "var(--tezex-action-text)",
        opacity: 0.72,
      },
      "&.Mui-focusVisible": {
        outlineColor: "var(--tezex-panel)",
      },
    },
  },
  slippageInput: {
    width: "100%",
    minWidth: 0,
    height: "28px",
    minHeight: "28px",
    maxHeight: "28px",
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    boxSizing: "border-box",
    zIndex: 1,
    "& .MuiInputBase-root": {
      margin: 0,
    },
    "& .MuiInputBase-input": {
      minWidth: 0,
      height: "28px",
      minHeight: "28px",
      maxHeight: "28px",
      padding: 0,
      boxSizing: "border-box",
      color: "var(--tezex-action-text)",
      WebkitTextFillColor: "var(--tezex-action-text)",
      fontFamily: "Inter",
      fontWeight: 700,
      fontSize: "11px",
      lineHeight: 1,
      textAlign: "right",
    },
  },
  slippageInputProps: {
    width: "100%",
    height: "28px",
    minHeight: "28px",
    maxHeight: "28px",
    padding: "0 9px",
    margin: 0,
    overflow: "hidden",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--tezex-action-text)",
    background: "transparent",
    borderRadius: "999px",
  },
  slippageEndAdornment: {
    height: "28px",
    maxHeight: "28px",
    marginLeft: "2px",
    color: "var(--tezex-action-text)",
    "& .MuiTypography-root": {
      color: "inherit",
      fontFamily: "Inter",
      fontWeight: 700,
      fontSize: "11px",
      lineHeight: 1,
    },
  },
});

export const darkStyle = segmentedSlippageStyle;

export default segmentedSlippageStyle;
